export default function getFormData(recipeData = null) {
  const formData = {
    name: recipeData?.name || '',
    description: recipeData?.description || '',
    image: null,
    source_recipe_url: recipeData?.sourceRecipeUrl || '',
    for_how_many_person: recipeData?.forHowManyPersonCode || '',
    time_consuming: recipeData?.timeConsumingCode || '',
    mealTypes: [],
    groups: [
      {
        key: '67c3f5ec-18b0-4406-b9b8-21e4b7c90c7d',
        name: ''
      }
    ],
    ingredients: [
      {
        key: '21a3f5ec-18b0-4406-b9b8-21e4b7140d5c',
        group: '67c3f5ec-18b0-4406-b9b8-21e4b7c90c7d',
        selected: null,
        quantity: "",
      }
    ],
    appliances: [{}],
    stepGroups: [
      {
        key: '35acf5ec-18b0-4406-b9b8-21e4b7c90c7d',
        name: ''
      }
    ],
    steps: [
      {
        key: '36a7f5ec-18b0-4406-b9b8-21e4b7140d5c',
        group: '35acf5ec-18b0-4406-b9b8-21e4b7c90c7d',
        description: '',
        images: []
      }
    ]
  };

  if (recipeData) {
    formData.mealTypes = getMealTypesData(recipeData);

    const stepData = getRecipeStepData(recipeData);
    formData.stepGroups = stepData.groups;
    formData.steps = stepData.steps;

    const ingredientData = getRecipeIngredientData(recipeData);

    formData.groups = ingredientData.groups;
    formData.ingredients = ingredientData.ingredients;

    formData.appliances = getRecipeApplianceData(recipeData);

    formData.image = getRecipeImageData(recipeData);
  }

  return formData;
}

function getMealTypesData(recipeData) {
  return recipeData?.mealTypes?.map(mealType => ({
    value: mealType.id,
    label: mealType.name,
  }));
}

function getRecipeStepData(recipeData) {
  const groups = {};
  const steps = [];

  recipeData?.steps?.forEach(step => {
    const groupData = {key: step.groupId, name: step.groupName};
    if (groups[step.groupId] === undefined) {
      groups[step.groupId] = groupData;
    }

    const stepData = {
      key: step.id,
      id: step.id ?? null,
      group: step.groupId,
      description: step.stepDescription,
      images: step.images?.map(image => ({
        id: image.id,
        path: image.filename,
        filename: image.filename,
        preview: image.url,
        url: image.url,
      }))
    };

    steps.push(stepData);
  });

  return {
    groups: Object.values(groups),
    steps
  }
}

function getRecipeIngredientData(recipeData) {
  const groups = {};
  const ingredients = [];

  recipeData?.ingredients?.forEach(ingredient => {
    const groupData = {key: ingredient.groupId, name: ingredient.groupName};
    if (groups[ingredient.groupId] === undefined) {
      groups[ingredient.groupId] = groupData;
    }

    const ingredientData = {
      key: ingredient.id,
      group: ingredient.groupId,
      selected: {
        value: ingredient.id,
        label: ingredient.nameInRecipe ?? ingredient.name,
        allowedUnits: []
      },
      quantity: ingredient.quantity
    };

    ingredients.push(ingredientData);
  });

  return {
    groups: Object.values(groups),
    ingredients
  }
}

function getRecipeApplianceData(recipeData) {
  const appliances = [];

  recipeData?.equipments?.forEach(appliance => {
    const applianceData = {
      selected: {
        value: appliance.id,
        label: appliance.name,
      },
    };

    appliances.push(applianceData);
  });

  return appliances;
}

function getRecipeImageData(recipeData) {
  if (recipeData.photo) {
    return {
      id: recipeData.photo.id,
      path: recipeData.photo.filename,
      filename: recipeData.photo.filename,
      preview: recipeData.photo.url,
      url: recipeData.photo.url
    }
  }
  return '';
}
